import { styled } from '@mui/material/styles';
import { SharedContainerStepsStyles } from '../shared/styles/sharedBookingStyles';
export const StyledContainer = styled('section')(
  ({ theme }) => `
  ${SharedContainerStepsStyles({ theme })}
`,
);
